<script lang="ts" setup>
import { inject, PropType, ref } from 'vue';
import { ItemHelper as ItemHelperClass } from '../helpers/item.helper';
import { OverlaysService } from '../services/overlays.service';
import { IItem } from '../interfaces/cart.interfaces';
import { TranslationService } from '../services/translation.service';
import { EOverlay } from '../EOverlay';
import { CartService } from '../services/cart.service';

const ItemHelper = inject<ItemHelperClass>('ItemHelper')!;
const overlaysSvc = inject<OverlaysService>('overlaysSvc')!;
const t = inject<TranslationService>('translationSvc')!.t
const cartSvc = inject<CartService>('cartSvc')!
const { overlayData, hasChemCas, hasProductInfoWImg, isLoggedIn, item } = defineProps(
  {
    overlayData: {
      type: Object as PropType<IItem>,
      required: true
    },
    hasChemCas: {
      type: Boolean,
      required: true
    },
    hasProductInfoWImg: {
      type: Boolean,
      required: true
    },
    isLoggedIn: {
      type: Boolean,
      required: true
    },
    item: {
      type: Object as PropType<IItem>,
      required: true
    }
  }
)

item.qty = 1
ItemHelper.attachCasData(overlayData)

</script>

<template>
  <div class="row products-list-row">
    <div class="col-xs-5 col-sm-4 visible-xs visible-sm bold text-right">
      {{ t("PRODUCT_DESCRIPTION") }}
    </div>
    <div class="col-xs-7 col-sm-8 col-md-4 col-name text-wrap">
      <span break-except-words="item.ItemName"></span><br />
      <span>pack size:</span> <span>{{ item.Packsize }}</span>

      <div v-if="item.CAS">
        <span>CAS:</span>
        <a class="link-cas"
           @click="overlaysSvc.showOverlay(EOverlay.productInfo, undefined, overlayData)">{{ item.CAS }}</a>
      </div>
    </div>
    <div class="col-xs-5 col-sm-4 visible-xs visible-sm bold text-right">
      {{ t("ARTICLE_NUMBER") }}</div>
    <div class="col-xs-7 col-sm-8 col-md-2 col-code">
      <div>{{ item.ItemCode }}</div>
      <div v-if="hasChemCas || hasProductInfoWImg" class="pt-10 pt-m-5 pb-m-5">
        <div class="btn-label btn-cb button-productinfo"
             @click="overlaysSvc.showOverlay(EOverlay.productInfo, undefined, overlayData)">
          {{ t("BTN_ITEM_INFO") }}
        </div>
      </div>
    </div>
    <div class="col-xs-5 col-sm-4 visible-xs visible-sm bold text-right">
      {{ t("BRAND") }}</div>
    <div class="col-xs-7 col-sm-8 col-md-1 col-brand">{{ item.BrandName }}</div>
    <div class="col-xs-5 col-sm-4 visible-xs visible-sm bold text-right">
      {{ t("AVAILABILITY") }}*
    </div>
    <div class="col-xs-7 col-sm-8 col-md-2 col-stock"
         v-text="ItemHelper.availOrLeadText(
          item,
          ` ${t('PRODUCTS_UNITS')}`,
          t('PRODUCTS_ON_REQUEST'),
          ` ${t('PRODUCTS_WORKDAYS')}`,
          t('PRODUCTS_TO_BE_CONFIRMED')
        )">
    </div>
    <div class="col-xs-5 col-sm-4 visible-xs visible-sm bold text-right">chf</div>
    <div class="col-xs-7 col-sm-6 col-md-2 col-price">
      <span :class='{ bold: true, "color-specialPrice": cartSvc.hasItemSpecialPrice(item) }'
            v-text="cartSvc.getItemSinglePrice(item)?.toFixed(2)"></span>
    </div>
    <div class="col-xs-8 visible-xs"><br></div>
    <div class="col-xs-4 col-sm-2 col-md-1 col-cart">
      <a class="pull-right cart-icon bgBlackFgWhite hoverBgWhiteFgBlack"
         @click="isLoggedIn ? cartSvc.addItemToCart(item, item.qty) : overlaysSvc.showOverlay(EOverlay.loginForm)">
        <span
              class="btn-cart btn-small"></span></a>
      <div><input type="number" min="1" value="1" v-model="item.qty"
               :disabled="!isLoggedIn"></div>
    </div>
  </div>

</template>
